import { FC } from 'react'

import './style.scss'

type DropdownProps = {
  className?: string,
  show: boolean,
  style?: any
}

const Dropdown:FC<DropdownProps> = ({ children, className = '', show = false, style  })  => {
  return (
    <div className={`dropdown ${show ? 'dropdown--active' : ''} ${className}`} style={style}>
      {children}
    </div>
  )
}

export { Dropdown }